/* tslint:disable */
/* eslint-disable */
/**
 * Sports App Training Plans
 * API for the Sports App Training Plans
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateDeckDTO
 */
export interface UpdateDeckDTO {
    /**
     * 
     * @type {string}
     * @memberof UpdateDeckDTO
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDeckDTO
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDeckDTO
     */
    imageId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDeckDTO
     */
    ownerId?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateDeckDTO
     */
    deckImageNumber?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateDeckDTO
     */
    editorIds?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateDeckDTO
     */
    cardBackImageIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UpdateDeckDTO
     */
    id: string;
}

/**
 * Check if a given object implements the UpdateDeckDTO interface.
 */
export function instanceOfUpdateDeckDTO(value: object): value is UpdateDeckDTO {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function UpdateDeckDTOFromJSON(json: any): UpdateDeckDTO {
    return UpdateDeckDTOFromJSONTyped(json, false);
}

export function UpdateDeckDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateDeckDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'imageId': json['imageId'] == null ? undefined : json['imageId'],
        'ownerId': json['ownerId'] == null ? undefined : json['ownerId'],
        'deckImageNumber': json['deckImageNumber'] == null ? undefined : json['deckImageNumber'],
        'editorIds': json['editorIds'] == null ? undefined : json['editorIds'],
        'cardBackImageIds': json['cardBackImageIds'] == null ? undefined : json['cardBackImageIds'],
        'id': json['id'],
    };
}

export function UpdateDeckDTOToJSON(json: any): UpdateDeckDTO {
    return UpdateDeckDTOToJSONTyped(json, false);
}

export function UpdateDeckDTOToJSONTyped(value?: UpdateDeckDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'imageId': value['imageId'],
        'ownerId': value['ownerId'],
        'deckImageNumber': value['deckImageNumber'],
        'editorIds': value['editorIds'],
        'cardBackImageIds': value['cardBackImageIds'],
        'id': value['id'],
    };
}

